// extracted by css-extract-rspack-plugin
export default {"cls1":"reassurance_pill-cls1_rUt","cls2":"reassurance_pill-cls2_YBN reassurance_pill-cls1_rUt"};